import { UserRole } from '../types/user';

/** Roles with full member workspace access (Analysis, Policies, Projects). */
export const CLIMATE_PLANS_MEMBER_ROLES: UserRole[] = [
  'super_admin',
  'local_govt_admin',
  'developer',
  'academic',
];

/** Roles that can use advanced GHG Scenarios expand controls. */
export const CLIMATE_PLANS_ADMIN_ROLES: UserRole[] = [
  'super_admin',
  'local_govt_admin',
  'developer',
];

export type MemberFeatureGateId = 'analysis' | 'policies' | 'projects';

export const MEMBER_FEATURE_GATE_COPY: Record<
  MemberFeatureGateId,
  { title: string; message: string; subtext: string }
> = {
  analysis: {
    title: 'Analysis',
    message:
      'Statewide analysis dashboards, publication figures, and benchmarking tools are available to CoolClimate Network members.',
    subtext:
      'Members use these tools for inventory reporting, peer comparisons, and climate intelligence across California jurisdictions.',
  },
  policies: {
    title: 'Policy Intelligence Dashboard',
    message:
      'The Policy Intelligence Dashboard, policy library, and law impact explorer are available to CoolClimate Network members.',
    subtext:
      'Members search adopted local policies, compare measures, and connect policy text to emissions and implementation data.',
  },
  projects: {
    title: 'Projects',
    message:
      'The climate project pipeline and implementation workspace are available to CoolClimate Network members.',
    subtext:
      'Members track CAP measures, funding opportunities, and project readiness in a shared local-government workspace.',
  },
};

export const SCENARIOS_EXPAND_ADMIN_MESSAGE =
  'Detailed policy levers and sub-measures (+ expand controls) are advanced tools available to local government members through CoolClimate Network membership.';

export const SCENARIOS_EXPAND_ADMIN_SUBTEXT =
  'Main scenario sliders remain free to explore. Members unlock detailed controls for parking pricing, compact development, building electrification, and more.';
